/* PartnerDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _11 = "._4cvr1h6o{align-items:center}";
const _10 = "._1e0c1txw{display:flex}";
const _9 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _8 = "._4t3i1k8s{height:1.5rem}";
const _7 = "._1bsb1k8s{width:1.5rem}";
const _6 = "._o5721q9c{white-space:nowrap}";
const _5 = "._1bto1l2s{text-overflow:ellipsis}";
const _4 = "._18m915vq{overflow-y:hidden}";
const _3 = "._1reo15vq{overflow-x:hidden}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Tooltip from '@atlaskit/tooltip';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal } from '@atlassian/mpac-primitives';
import { resolvePartnerTier } from '@atlassian/mpac-ui';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._k48p1nn1{font-weight:400}";
const _ = "._19pkidpf{margin-top:0}";
const PartnerDetailsContainer = null;
const PartnerBadgeImage = null;
const HelperText = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HelperText.displayName = 'HelperText';
}
const HelperTextStyle = null;
const PartnerBadgeImageContainer = null;
const PartnerName = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1bto1l2s _o5721q9c _19pkidpf _k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PartnerName.displayName = 'PartnerName';
}
const PartnerNameStyle = null;
const PartnerBadge = props => {
  const partnerTierType = resolvePartnerTier(props.partnerTier);
  if (!partnerTierType) {
    return null;
  }
  const tooltipText = "".concat(capitalize(partnerTierType.label.toLowerCase()), " partner");
  return /*#__PURE__*/_jsx(Tooltip, {
    content: tooltipText,
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_7, _8]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1bsb1k8s _4t3i1k8s"]),
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8, _7]
          }), /*#__PURE__*/_jsx("img", {
            alt: "".concat(partnerTierType.label, " Marketplace Partner"),
            src: partnerTierType.badge,
            className: ax(["_4t3i1k8s _1bsb1k8s"])
          })]
        })
      })]
    })
  });
};
export const PartnerDetails = props => {
  const {
    name,
    partnerTier
  } = props;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  return enableMpacWebCoherence() ? /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_zulp1b66 _1e0c1txw _4cvr1h6o"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _12]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_19pkidpf _k48p1nn1 _ect41gqc"]),
          children: "by"
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6, _, _2]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_1reo15vq _18m915vq _1bto1l2s _o5721q9c _19pkidpf _k48p1nn1"]),
          children: name
        })]
      }), /*#__PURE__*/_jsx(PartnerBadge, {
        partnerTier: partnerTier
      })]
    })]
  }) : /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_zulp1b66 _1e0c1txw _4cvr1h6o"]),
      children: [/*#__PURE__*/_jsx(HelperText, {
        children: "by"
      }), /*#__PURE__*/_jsx(PartnerName, {
        children: name
      }), /*#__PURE__*/_jsx(PartnerBadge, {
        partnerTier: partnerTier
      })]
    })]
  });
};